const state = () => ({
    data: [],
    loading: false,
})

const getters = {}

const actions = {
    async get({commit}, {checkoutOrderId} = {}) {
        commit('setLoading', true)

        try {
            const res = await this._vm.axios.get(this._vm.endpoints['ecommerce_checkout_note'], {
                urlVars: {checkoutOrderId}
            })
            commit('updateData', res.data?.data || [])
        } catch (error) {
            this._vm.onResponseFailure(error.response.data);
        } finally {
            commit('setLoading', false)
        }
    },

    async add({commit}, {checkoutOrderId, formData}) {
        try {
            const res = await this._vm.axios.post(this._vm.endpoints['ecommerce_checkout_note'], formData, {
                urlVars: {checkoutOrderId}
            })
            return res.data
        } catch (error) {
            this._vm.onResponseFailure(error.response.data);
        }
    },

    async delete({commit}, {checkoutOrderId, id}) {
        try {
            const res = await this._vm.axios.delete(this._vm.endpoints['ecommerce_checkout_note'] + '/' + id, {
                urlVars: {checkoutOrderId}
            })
            return res.data
        } catch (error) {
            this._vm.onResponseFailure(error.response.data);
        }
    },
}

const mutations = {
    setLoading(state, val) {
        state.loading = val
    },
    updateData(state, data) {
        state.data = data
    },
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
}
